import Tilt from "react-tilt";

const About = () => {
  return (
    <section id="about">
    <div className="home-image" data-aos="fade-left" data-aos-mirror="true">
        <Tilt options={{ max: 25, scale: 1 }} className="Tilt">
          <img
            src="../../images/portfolio.gif"
            alt="home-img"
            className="Tilt-inner"
          ></img>
        </Tilt>
      </div>

      <div className="about-content">
        <div data-aos="fade-down">
          <h1 className="about-heading">
            <i className="fa-solid fa-user"></i> ABOUT ME
          </h1>
          
          <hr></hr>
        </div>
        <div data-aos="fade-down" data-aos-mirror="true">
          <p>
          • Hello! My name is Abhishek Kumar and I enjoy coding and learning new technologies.
          </p>
          <p>
          • I'm a passionate Developer, with strong communication skills and the ability to write efficient code using MERN stack.
          </p>
          <p>
          • My interest in Web Development started when I was trying to edit things on the web, that taught me a lot about HTML & CSS.
          </p>
          <p>
          • Fast Forwarding today, I build a number of web applications and 3 major projects. Learnt about teamwork, leadership, and communication.
          </p>
          <p>
          • After months of rigorous training, here I am looking for an oportunity as a Full Stack Web Developer.
          </p>
          
        </div>
      </div>
    </section>
  );
};
export default About;
